import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  fetchReport,
  onLogin,
  fetchReviewsByUser,
  saveReview,
  startChat,
} from '~actions'; // eslint-disable-line
// Components
import ReviewsContainer from './ReviewsContainer';

const propTypes = {
  match: PropTypes.object,
  locale: PropTypes.object.isRequired,
  session: PropTypes.object,
  userReviews: PropTypes.object.isRequired,
  fetchReviewsByUser: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  saveReview: PropTypes.func.isRequired,
  startChat: PropTypes.func.isRequired,
  report: PropTypes.object.isRequired,
};

class UserReviews extends Component {
  componentWillMount() {
    const { params } = this.props.match;
    const { userId } = params;
    this.props.fetchReviewsByUser({ userId });
  }

  _onLogin(authData) {
    const data = authData;
    const { country, identifier } = this.props.match.params;
    if (!country || !identifier) {
      this.props.onLogin(data);
      return;
    }

    data.country = country;
    data.identifier = identifier;
    this.props.onLogin(data);
  }

  render() {
    const { userReviews, session, locale, report } = this.props;

    if (!userReviews || !userReviews.reviews) return null;

    let currentReview = {};
    if (report) {
      userReviews.reviews.forEach((review) => {
        if (report.identifier === review.company.identifier) {
          currentReview = review;
        }
      })
    }

    return (
      <div className="UserReviews">
        <ReviewsContainer
          locale={locale}
          session={session}
          reviews={userReviews.reviews}
          user={{ name: userReviews.name }}
          onLogin={this._onLogin}
          saveReview={this.props.saveReview}
          startChat={this.props.startChat}
          review={currentReview}
        />
      </div>
    );
  }
}

UserReviews.propTypes = propTypes;

// This makes state objects available to the component via props!
function mapStateToProps(state) {
  return {
    report: state.report,
    userReviews: state.userReviews,
    session: state.session,
    locale: state.locale,
  };
}

// This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchReport,
      fetchReviewsByUser,
      onLogin,
      saveReview,
      startChat,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UserReviews);
